import { useQuery } from '@tanstack/react-query';

import { GateCheck, listGateChecks } from '@/services/workflow/qualification';

export const GATE_CHECKS_QUERY_KEY = 'gate-checks';

/**
 * The vocabulary for a wave's check lists. The API refuses an unknown key
 * outright, so configuration has to be a choice from this list rather than
 * free text.
 */
export const useGateChecks = () =>
  useQuery<GateCheck[], Error>({
    queryKey: [GATE_CHECKS_QUERY_KEY],
    queryFn: ({ signal }) => listGateChecks(signal),
    // Registered in code, so it only changes on deploy.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
